import { Component, HostListener, inject, Input, OnInit } from '@angular/core';
import {
  accreditationProfile,
  menuPermissions,
  programProfile,
  Session
} from "../../../../services/session.service";
import { GenericService } from "../../../../services/generic.service";
import { environment } from "../../../../../environments/environment";
import { RoutesEnum } from "../../../../enums/routes.enum";

@Component({
  selector: 'app-burger-menu',
  templateUrl: './burger-menu.component.html',
  styleUrl: './burger-menu.component.scss',
  standalone: false
})
export class BurgerMenuComponent implements OnInit {
  @Input() canShowMenu: menuPermissions;
  dashboardLink: string;


  myWorkOpen: boolean = false;
  libraryOpen: boolean = false;
  analyticsOpen: boolean = false;

  isNewApplicant: boolean = false;
  isAccreditor: boolean = false;
  isFederation: boolean = false;

  projects = [];

  institutionalProfiles: accreditationProfile[];
  accreditationProfiles: accreditationProfile[];
  programProfiles: programProfile[];

  programRequestKey: string = null;
  directoryProgramRequestKey: string = null;

  directoryInstitutionRequestKey: string = null;

  canAccessInstitutionalDirectory: boolean = false;
  canAccessProgramDirectory: boolean = false;

  debug: boolean;

  private readonly session:Session = inject(Session);
  private readonly genericService:GenericService = inject(GenericService);

  @HostListener('document:click', ['$event'])
  click(event) {
    if(
      !this.genericService.isDescendant("mainMenu", event.target)  &&
      !event.target.classList.contains("submenu")
    ) {
      this.myWorkOpen = false;
      this.libraryOpen = false;
      this.analyticsOpen = false;
    }
  }

  ngOnInit() {
    this.isAccreditor = this.session.getUser().userOrganizationData.isAccreditor;
    this.isFederation = this.session.getUser().userOrganizationData.isFederation;
    this.canAccessInstitutionalDirectory = this.session.getUser().appPermissions.canAccessDirectory;
    this.canAccessProgramDirectory = this.session.getUser().appPermissions.canAccessProgramDirectory;
    if(this.session.isNewApplicant() ) {
      this.isNewApplicant = true;
    }
    this.directoryProgramRequestKey = this.session.getDirectoryProgramRequestKey();

    this.directoryInstitutionRequestKey = this.session.getAccountDirectoryInstitutionRequestKey();
    this.programRequestKey = this.session.getAccountAccreditationProgramRequestKey();
    this.programProfiles = this.session.getProgramInstitutionDirectoryProfiles();
    this.accreditationProfiles = this.session.getInstitutionDirectoryProfiles();

    this.debug = environment.enableDebug;
    this.projects = this.session.getUser().userData.projects;
  }

  protected readonly RoutesEnum = RoutesEnum;
}
